/** Tiny classNames joiner — avoids a dependency for the common conditional case. */
export function clsx(
  ...parts: (string | false | null | undefined)[]
): string {
  return parts.filter(Boolean).join(" ");
}
